/**
 * ThemeToggle — кнопка переключения светлой / тёмной темы.
 *
 * Размещается в верхней панели рядом с SystemHealthBadge.
 */
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/utils/cn';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="btn-theme-toggle"
      data-theme={theme}
      title={isDark ? 'Светлая тема' : 'Тёмная тема'}
      aria-label={isDark ? 'Включить светлую тему' : 'Включить тёмную тему'}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-2xl border border-shell-border bg-shell-surface text-shell-muted transition',
        'hover:text-shell-primary hover:border-shell-primary/40 hover:bg-shell-primary-soft',
        'focus:outline-none focus:ring-2 focus:ring-shell-primary/30',
        className,
      )}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
